import moment from 'moment'

const tipoEncaminhamento = (status) => {
  const titulos = {
    ENCAMINHADO: 'Encaminhamento realizado',
    ACEITO: 'Encaminhamento recebido',
    CANCELADO: 'Encaminhamento cancelado',
    NEGADO: 'Encaminhamento negado',
  }
  return titulos[status] || 'Encaminhamento'
}

const tipoPassagemCustodia = (status) => {
  const titulos = {
    SOLICITADO: 'Passagem de custódia solicitada',
    ACEITO: 'Passagem de custódia aceita',
    CANCELADO: 'Passagem de custódia cancelada',
    NEGADO: 'Passagem de custódia negada',
  }
  return titulos[status] || 'Passagem de Custódia'
}

const getUsuarioEncaminhamento = (encaminhamento) => {
  if (!encaminhamento) return null
  const status = encaminhamento.status
  if (status === 'ACEITO' || status === 'NEGADO') {
    return encaminhamento.usuDest
  }
  return encaminhamento.usuOrig
}

const iconeEncaminhamento = (status) => {
  const icones = {
    ENCAMINHADO: 'fas fa-people-arrows',
    ACEITO: 'fas fa-check',
    NEGADO: 'fas fa-exclamation-triangle',
    CANCELADO: 'fas fa-times',
  }
  return icones[status] || 'fas fa-people-arrows'
}

const iconePassagemCustodia = (status) => {
  const icones = {
    SOLICITADO: 'fas fa-people-arrows',
    ACEITO: 'fas fa-check',
    NEGADO: 'fas fa-exclamation-triangle',
    CANCELADO: 'fas fa-times',
  }
  return icones[status] || 'fas fa-people-arrows'
}

const dadosEncaminhamento = (encaminhamento) => {
  const usuario = getUsuarioEncaminhamento(encaminhamento)
  const nome = usuario ? `Nome: ${usuario.nome || ''} ${usuario.sobrenome || ''}`.trim() : 'Nome: -'
  const cargo = `Cargo: ${usuario?.cargo?.nome || ' - '}`
  const matricula = `Matricula: ${usuario?.matricula || ' - '}`

  return {
    tipo: tipoEncaminhamento(encaminhamento.status),
    textData: 'Data do encaminhamento',
    itens: [
      nome,
      cargo,
      matricula,
      `Origem: ${encaminhamento.setOrig?.nome || ' - '}`,
      `Destino: ${encaminhamento.setDest?.nome || ' - '}`,
      `Observações: ${encaminhamento.observacao || ' - '}`,
    ],
    data: new Date(encaminhamento.dataOrigem || encaminhamento.createdAt),
    icon: iconeEncaminhamento(encaminhamento.status),
    color: 'primary',
  }
}

const dadosPassagemCustodia = (passagemCustodia) => {
  const usuOrig = passagemCustodia.usuOrig || {}
  const usuDest = passagemCustodia.usuDest || {}
  return {
    tipo: tipoPassagemCustodia(passagemCustodia.status),
    textData: 'Data',
    itens: [
      `Usuário origem: ${usuOrig.nome || ''} ${usuOrig.sobrenome || ''}`.trim() || ' - ',
      `Usuário destino: ${usuDest.nome || ''} ${usuDest.sobrenome || ''}`.trim() || ' - ',
      `Setor: ${passagemCustodia.set?.nome || ' - '}`,
      `Observações: ${passagemCustodia.observacao || ' - '}`,
    ],
    data: new Date(passagemCustodia.createdAt),
    icon: iconePassagemCustodia(passagemCustodia.status),
    color: 'primary',
  }
}

const dadosRetirada = (retirada) => {
  const recep = retirada.recep || {}
  const nome = `Retirado por: ${recep.nome || ''} ${recep.sobrenome || ''}`.trim()
  return {
    tipo: 'Retirado para exame',
    textData: 'Data da retirada',
    itens: [
      nome || 'Retirado por: -',
      `Cargo: ${recep.cargo?.nome || ' - '}`,
      `Matricula: ${recep.matricula || ' - '}`,
      `Número do lacre: ${retirada.lacre || ' - '}`,
    ],
    data: new Date(retirada.data),
    icon: 'fas fa-chevron-right',
    color: 'primary',
  }
}

const dadosDevolucao = (devolucao) => {
  const entreg = devolucao.entreg || {}
  const oper = devolucao.oper || {}
  return {
    tipo: 'Devolução pós exame',
    textData: 'Data da devolução',
    itens: [
      `Devolvido por: ${entreg.nome || ''} ${entreg.sobrenome || ''}`.trim() || 'Devolvido por: -',
      `Cargo: ${entreg.cargo?.nome || ' - '}`,
      `Matricula: ${entreg.matricula || ' - '}`,
      `Número do lacre: ${devolucao.lacre || ' - '}`,
      '___',
      `Recebido por: ${oper.nome || ''} ${oper.sobrenome || ''}`.trim() || 'Recebido por: -',
      `Cargo: ${oper.cargo?.nome || ' - '}`,
      `Matricula: ${oper.matricula || ' - '}`,
      `Lacre: ${devolucao.lacre || ' - '}`,
    ],
    data: new Date(devolucao.data),
    icon: 'fas fa-chevron-right',
    color: 'primary',
  }
}

const dadosGuardarVestigio = (guardamento) => {
  const usu = guardamento.usu || {}
  const nome = `${usu.nome || ''} ${usu.sobrenome || ''}`.trim()
  return {
    tipo: 'Guardado no setor',
    textData: 'Data que foi guardado',
    itens: [
      `Usuário: ${nome || '-'}` + `${usu.cargo?.nome ? ` - ${usu.cargo.nome}` : ''}` + `${usu.matricula ? ` - ${usu.matricula}` : ''}`,
      `Número do lacre: ${guardamento.lacre || ' - '}`,
      `Local guardado: ${guardamento.localizacao || ' - '}`,
    ],
    data: new Date(guardamento.createdAt),
    icon: 'fas fa-chevron-right',
    color: 'primary',
  }
}

const dadosClassificacao = (classificacao) => {
  const usu = classificacao.usu || {}
  const nome = `${usu.nome || ''} ${usu.sobrenome || ''}`.trim()
  return {
    tipo: 'Classificado',
    textData: 'Data da classificação',
    itens: [
      `Usuário: ${nome || '-'}` + `${usu.cargo?.nome ? ` - ${usu.cargo.nome}` : ''}`,
      `Tipo: ${classificacao.tipo || ' - '}`,
      `Setor: ${classificacao.setor?.nome || ' - '}`,
    ],
    data: new Date(classificacao.createdAt),
    icon: 'fa fa-tags',
    color: 'primary',
  }
}

const dadosDesmembramento = (desmembramento) => {
  const usu = desmembramento.usu || {}
  const nome = `${usu.nome || ''} ${usu.sobrenome || ''}`.trim()
  return {
    tipo: 'Desmembrado',
    textData: 'Data do desmembramento',
    itens: [
      `Usuário: ${nome || '-'}` + `${usu.cargo?.nome ? ` - ${usu.cargo.nome}` : ''}`,
      `Setor: ${desmembramento.setor?.nome || ' - '}`,
      `Novos identificadores: ${desmembramento.novosIdentificadores || ' - '}`,
      `Lacre: ${desmembramento.lacre || ' - '}`,
    ],
    data: new Date(desmembramento.createdAt),
    icon: 'fa fa-sitemap',
    color: 'primary',
  }
}

const dadosCriacaoPorDesmembramento = (criacaoDesmembramento) => {
  const usu = criacaoDesmembramento.usu || {}
  const nome = `${usu.nome || ''} ${usu.sobrenome || ''}`.trim()
  return {
    tipo: 'Reagrupado em desmembramento',
    textData: 'Data do reagrupamento',
    itens: [
      `Usuário: ${nome || '-'}` + `${usu.cargo?.nome ? ` - ${usu.cargo.nome}` : ''}`,
      `Setor: ${criacaoDesmembramento.setor?.nome || ' - '}`,
      `Lacre: ${criacaoDesmembramento.lacre || ' - '}`,
    ],
    data: new Date(criacaoDesmembramento.createdAt),
    icon: 'fa fa-sitemap',
    color: 'primary',
  }
}

const dadosCriacaoPorExtracao = (criacaoExtracao) => {
  const usu = criacaoExtracao.usu || {}
  const nome = `${usu.nome || ''} ${usu.sobrenome || ''}`.trim()
  return {
    tipo: 'Extraído em exame',
    textData: 'Data de extração',
    itens: [
      `Usuário: ${nome || '-'}` + `${usu.cargo?.nome ? ` - ${usu.cargo.nome}` : ''}`,
      `Setor: ${criacaoExtracao.setor?.nome || ' - '}`,
      `Lacre: ${criacaoExtracao.lacre || ' - '}`,
    ],
    data: new Date(criacaoExtracao.createdAt),
    icon: 'fa fa-sitemap',
    color: 'primary',
  }
}

const dadosDescarte = (vestigio) => {
  const usuAut = vestigio.usuAutDesc || {}
  const autorizador = `Autorização para descarte: ${usuAut.nome || ''} ${usuAut.sobrenome || ''}`.trim()
  return {
    tipo: 'Descarte',
    textData: 'Data do descarte',
    itens: [
      autorizador || 'Autorização para descarte: -',
      `Documento de autorização: ${vestigio.numeroAutorizacaoDescarte || ' - '}`,
      `Data: ${moment(vestigio.dataAutorizacaoDescarte).format('LLLL')}`,
      '___',
    ],
    data: new Date(vestigio.dataDescarte),
    icon: 'fas fa-trash',
    color: 'primary',
  }
}

const dadosEntrega = (entrega) => {
  const usu = entrega.usu || {}
  const usuRec = entrega.usuRec || {}
  const nomeUsu = `${usu.nome || ''} ${usu.sobrenome || ''}`.trim()
  const nomeUsuRec = `${usuRec.nome || ''} ${usuRec.sobrenome || ''}`.trim()
  return {
    tipo: 'Entregue',
    textData: 'Data da entrega',
    itens: [
      `Usuário: ${nomeUsu || '-'}` + `${usu.cargo?.nome ? ` - ${usu.cargo.nome}` : ''}`,
      `Setor: ${entrega.setor?.nome || ' - '}`,
      `Lacre: ${entrega.lacre || ' - '}`,
      `Identificador: ${entrega.identificador || ' - '}`,
      `Setor destino: ${entrega.setDest?.nome || ' - '}`,
      `Usuário recebedor: ${nomeUsuRec || '-'}`,
    ],
    data: new Date(entrega.createdAt),
    icon: 'fas fa-chevron-right',
    color: 'primary',
  }
}

const dadosInformacaoAdicionada = (informacao) => {
  const usu = informacao.usu || {}
  const nome = `${usu.nome || ''} ${usu.sobrenome || ''}`.trim()
  return {
    tipo: 'Informação adicionada',
    textData: 'Data do cadastro da informação',
    itens: [
      `Usuario: ${nome || '-'}` + `${usu.cargo?.nome ? ` - ${usu.cargo.nome}` : ''}`,
      `Setor: ${informacao.setor?.nome || ' - '}`,
      `Lacre: ${informacao.lacre || ' - '}`,
      `Identificador: ${informacao.identificador || ' - '}`,
    ],
    data: new Date(informacao.createdAt),
    icon: 'fas fa-chevron-right',
    color: 'primary',
  }
}

const dadosVestigioConsumido = (consumo) => {
  const usuario = consumo.usuario || {}
  const nome = `${usuario.nome || ''} ${usuario.sobrenome || ''}`.trim()
  return {
    tipo: 'Vestígio consumido',
    textData: 'Data do consumo do vestígio',
    itens: [
      `Usuario: ${nome || '-'}` + `${usuario.cargo?.nome ? ` - ${usuario.cargo.nome}` : ''}`,
      `Setor: ${consumo.setor?.nome || ' - '}`,
      `Lacre: ${consumo.lacre || ' - '}`,
      `Identificador: ${consumo.identificador || ' - '}`,
    ],
    data: new Date(consumo.createdAt),
    icon: 'fas fa-chevron-left',
    color: 'primary',
  }
}

const dadosVestigioRetornado = (retorno) => {
  const usuOrig = retorno?.usuOrig || {}
  const usuDest = retorno?.usuDest || {}
  const nomeUsuOrig = `${usuOrig.nome || ''} ${usuOrig.sobrenome || ''}`.trim()
  const nomeUsuDest = `${usuDest.nome || ''} ${usuDest.sobrenome || ''}`.trim()
  return {
    tipo: 'Vestígio retornou após entrega',
    textData: 'Data do retorno do vestígio',
    itens: [
      `Usuario Origem: ${nomeUsuOrig || '-'}` + `${usuOrig.cargo?.nome ? ` - ${usuOrig.cargo.nome.toUpperCase()}` : ''}`,
      `Usuario Destino: ${nomeUsuDest || '-'}` + `${usuDest.cargo?.nome ? ` - ${usuDest.cargo.nome.toUpperCase()}` : ''}`,
      `Setor Origem: ${retorno?.setOrig?.nome || ' - '}`,
      `Setor Destino: ${retorno?.setDest?.nome || ' - '}`,
      `Lacre: ${retorno?.lacre || ' - '}`,
      `Identificador: ${retorno?.identificador || ' - '}`,
    ],
    data: retorno ? new Date(retorno.createdAt) : new Date(),
    icon: 'fas fa-chevron-left',
    color: 'primary',
  }
}

const dadosAcao = (acaoCadeiaCustodia) => {
  switch (acaoCadeiaCustodia.tipo) {
    case 'ENCAMINHAMENTO':
      return dadosEncaminhamento(acaoCadeiaCustodia.encamin)

    case 'RETIRADA':
      return dadosRetirada(acaoCadeiaCustodia.retir)

    case 'DEVOLUCAO':
      return dadosDevolucao(acaoCadeiaCustodia.devol)

    case 'GUARDAMENTO':
      return dadosGuardarVestigio(acaoCadeiaCustodia.guard)

    case 'CRIACAO_POR_DESMEMBRAMENTO':
      return dadosCriacaoPorDesmembramento(acaoCadeiaCustodia.criDesm)

    case 'CRIACAO_POR_EXTRACAO':
      return dadosCriacaoPorExtracao(acaoCadeiaCustodia.criExt)

    case 'PASSAGEM_CUSTODIA':
      return dadosPassagemCustodia(acaoCadeiaCustodia.passagem)

    case 'ENTREGA':
      return dadosEntrega(acaoCadeiaCustodia.entrega)

    case 'INFORMACAO_ADICIONADA':
      return dadosInformacaoAdicionada(acaoCadeiaCustodia.infAddVest)

    case 'CONSUMO_VESTIGIO':
      return dadosVestigioConsumido(acaoCadeiaCustodia.consVest)

    case 'RETORNO':
      return dadosVestigioRetornado(acaoCadeiaCustodia.retornoVest)

    case 'CLASSIFICACAO':
      return dadosClassificacao(acaoCadeiaCustodia.classif)

    case 'DESMEMBRAMENTO':
      return dadosDesmembramento(acaoCadeiaCustodia.desmemb)

    default:
      return {}
  }
}

const dadosFixacao = (vestigio) => {
  const usuAcond = vestigio.usuAcond || {}
  const usuFix = vestigio.usuFix || {}
  const nome = usuAcond.nome?.toLowerCase() === 'outro' ? vestigio.acondicionamentoInput : `${usuAcond.nome || ''} ${usuAcond.sobrenome || ''}`.trim()
  return {
    tipo: 'Fixado',
    textData: 'Data da fixação',
    itens: [
      `Nome: ${nome || ' - '}`,
      `Cargo: ${usuFix.cargo?.nome ? `${usuFix.cargo.nome}` : ' - '}`,
      `Matricula: ${usuFix.matricula || ' - '}`,
    ],
    data: new Date(vestigio.dataFixacao),
    icon: 'fas fa-briefcase',
    color: 'secondary',
  }
}

const dadosColeta = (vestigio) => {
  const usuCol = vestigio.usuCol || {}
  const nome = usuCol.nome?.toLowerCase() === 'outro' ? vestigio.coletaInput : `${usuCol.nome || ''} ${usuCol.sobrenome || ''}`.trim()
  return {
    tipo: 'Coletado',
    textData: 'Data da coleta',
    itens: [
      `Nome: ${nome || ' - '}`,
      `Cargo: ${usuCol.cargo?.nome ? `${usuCol.cargo.nome}` : ' - '}`,
      `Matricula: ${usuCol.matricula || ' - '}`,
    ],
    data: new Date(vestigio.dataColeta),
    icon: 'fas fa-briefcase',
    color: 'secondary',
  }
}

const dadosAcondicionamento = (vestigio) => {
  const usuAcond = vestigio.usuAcond || {}
  const nome = usuAcond.nome?.toLowerCase() === 'outro' ? vestigio.acondicionamentoInput : `${usuAcond.nome || ''} ${usuAcond.sobrenome || ''}`.trim()
  return {
    tipo: 'Acondicionado',
    textData: 'Data do acondicionamento',
    itens: [
      `Nome: ${nome || ' - '}`,
      `Cargo: ${usuAcond.cargo?.nome ? `${usuAcond.cargo.nome}` : ' - '}`,
      `Matricula: ${usuAcond.matricula || ' - '}`,
      `Lacre: ${vestigio.lacreAcondicionamento || ' - '}`,
    ],
    data: new Date(vestigio.dataAcondicionamento),
    icon: 'fas fa-lock',
    color: 'secondary',
  }
}

const dadosTransporte = (vestigio) => {
  const usuTrans = vestigio.usuTrans || {}
  const nome = usuTrans.nome?.toLowerCase() === 'outro' ? vestigio.transporteInput : `${usuTrans.nome || ''} ${usuTrans.sobrenome || ''}`.trim()
  return {
    tipo: 'Transportado',
    textData: 'Data do transporte',
    itens: [
      `Nome: ${nome || ' - '}`,
      `Cargo: ${usuTrans.cargo?.nome ? `${usuTrans.cargo.nome}` : ' - '}`,
      `Matricula: ${usuTrans.matricula || ' - '}`,
      `Lacre: ${vestigio.lacreAcondicionamento || ' - '}`,
    ],
    data: new Date(vestigio.dataTransporte),
    icon: 'fas fa-car',
    color: 'secondary',
  }
}

const dadosRecebimento = (vestigio) => {
  const usuRec = vestigio.usuRec || {}
  const nome = `${usuRec.nome || ''} ${usuRec.sobrenome || ''}`.trim()
  return {
    tipo: 'Recebido no setor',
    textData: 'Data do recebimento',
    itens: [
      `Nome: ${nome || ' - '}`,
      `Cargo: ${usuRec.cargo?.nome ? `${usuRec.cargo.nome}` : ' - '}`,
      `Matricula: ${usuRec.matricula || ' - '}`,
      `Lacre: ${vestigio.lacreAcondicionamento || ' - '}`,
    ],
    data: new Date(vestigio.dataRecebimento),
    icon: 'fas fa-people-arrows',
    color: 'primary',
  }
}

export const popularTimeLine = (vestigio) => {
  let acoes = []
  if (!vestigio) return acoes

  if (vestigio.id_usuario_transporte) {
    acoes.push(dadosFixacao(vestigio))
    acoes.push(dadosColeta(vestigio))
    acoes.push(dadosAcondicionamento(vestigio))
    acoes.push(dadosTransporte(vestigio))
    acoes.push(dadosRecebimento(vestigio))
  }

  if (vestigio.acoes) {
    vestigio.acoes.forEach((acaoCadeiaCustodia) => {
      const formatted = dadosAcao(acaoCadeiaCustodia)
      if (formatted && formatted.tipo) {
        acoes.push(formatted)
      }
    })
  }

  if (vestigio.id_usuario_descarte) {
    acoes.push(dadosDescarte(vestigio))
  }

  return acoes
}
